module.exports = __webpack_public_path__ + "img/chat_image.da8b162c.png";